// @core/api/endpoints/authn/verify_email.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  VerifyEmailRequest,
} from '../../../types/authn';

const BASE_PATH = '/authn';

/**
 * Verify email with token
 * Confirms a user's email address using the verification token sent to their inbox. This action marks the email as verified and may unlock additional platform features.
 * @public This endpoint does not require authentication
 */
export async function VerifyEmail(
  data: VerifyEmailRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/auth/email/verify`;
  const requestOptions = { ...options, skipAuth: true };
  return client.post<Response>(requestPath, data, requestOptions);
}
